import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Ticket } from "lucide-react";

export default function StickyBookButton({ onClick, label = "Book Now" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          onClick={onClick}
          className="fixed bottom-5 left-4 right-[92px] sm:left-1/2 sm:right-auto sm:-translate-x-1/2 z-40 flex items-center justify-center gap-2.5 px-7 py-3.5 bg-saffron text-ink font-medium text-sm tracking-wide shadow-lg shadow-black/50 hover:bg-gold transition-colors rounded-full"
          data-testid="sticky-book-btn">
          <Ticket size={16} /> {label}
        </motion.button>
      )}
    </AnimatePresence>
  );
}
